import { useQuery } from "@tanstack/react-query";

import { freshness, type FreshnessMeta } from "./api";
import { MapTab } from "./MapTab";
import { currentQuery } from "./parts";
import { SequenceTab } from "./SequenceTab";

/**
 * App journey (App journey viewer C5-C7, DEC-1324 A): the screens the current production build shows,
 * per flow and answers, read from the journey API (Ketosource/app-journey-api) through
 * functions/app-journey. The capture is made once per production release by app-build's app-journey
 * sub-skill; nothing here triggers or refreshes one.
 */

/** The freshness bridge: the capture time the API names in `meta` (one `current` call both tabs share). */
export function useAppJourneyMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const current = useQuery({ ...currentQuery(), enabled });
  if (!enabled) return undefined;
  return freshness(current.data?.meta);
}

/**
 * Tab content only. ShellPage wraps this in the shell-owned ModuleViewport and PermissionGate;
 * `decision` is accepted and not read (I-7): the module is read-only.
 */
export function AppJourneyModule({
  activeTabKey,
}: {
  decision: "edit" | "view" | "none";
  activeTabKey: string | null;
  areaName: string;
  ownerName?: string | null;
}) {
  if (activeTabKey === "map") return <MapTab />;
  return <SequenceTab />;
}
